import React from "react";
import Slider from "../../Slider/Slider";
import Faq from "../../Faq/Faq";

const data = {
  faqHeader: "Frequently Asked Questions - Shopify Development Services",
  caption:
    "Explore our Shopify development services with answers to common questions. For more information, feel free to contact our experienced team.",
  faqContent: [
    {
      ques: "How Does Shopify Support Mobile Commerce (M-commerce)?",
      ans: "Shopify supports M-commerce through responsive themes and a mobile-friendly design. The platform ensures that your online store is accessible and provides a seamless shopping experience across various devices, including smartphones and tablets. With Shopify, businesses can tap into the growing trend of mobile shopping and reach a wider audience.",
    },
    {
      ques: "What Integrations and Apps Can Enhance the Functionality of My Shopify Store?",
      ans: "Shopify offers a vast ecosystem of integrations and apps that can enhance the functionality of your store. Whether it's integrating with popular payment gateways, implementing marketing tools, or adding customer support features, Shopify's App Store provides a wide range of solutions to customize and optimize your e-commerce operations.",
    },
    {
      ques: "Can I Migrate My Existing E-commerce Store to Shopify?",
      ans: "Certainly! Shopify provides tools and resources for migrating existing e-commerce stores to its platform. Whether you're currently using another platform or have a custom-built solution, our Shopify development services include seamless migration processes. This ensures a smooth transition, allowing you to take advantage of Shopify's features and scalability.",
    },
    {
      ques: "How Does Shopify Ensure Fast Loading Times for E-commerce Websites?",
      ans: "Shopify ensures fast loading times for e-commerce websites through its robust infrastructure and content delivery network (CDN). By hosting your store on Shopify's servers and distributing content across multiple servers globally, Shopify minimizes load times for pages and images. This contributes to a positive user experience and can positively impact search engine rankings.",
    },
  ],
};


const ShopifyDev= () => {
  return (
    <>
      <div
        className="inner-page"
        id="nodejs-design-bg"
        data-aos="fade-up"
        data-aos-duration={1500}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div
                className="inner_content"
                data-aos="fade-up"
                data-aos-duration={2000}
              >
                <h1>Shopify Developer</h1>
                <div aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="index.html">
                        <i className="ri-home-4-line" />
                        Home
                      </a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Shopify Developer
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="bg-body-tertiary">
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-md-7">
                <h2 className="section-title">
                  Why Choose Shopify Website Development
                </h2>
                <p>
                  Shopify website development gives you a smart online store
                  with thousands of built-in attractive features. It provides an
                  amazing buying experience, making your customers come back
                  repeatedly. A Shopify eCommerce store provides ease of
                  management with minimum technical know-how. The shopping carts
                  developed on this platform offer easy checkout facilities with
                  various payment and shipping options integrated into them.
                  Marketing tools like Social Media Integration, Custom Gift
                  Cards, Product Reviews, Coupon Generators, and Discount Codes
                  can be integrated easily on this platform.
                </p>
              </div>
              <div className="col-md-5">
                <img
                  src="https://www.webguru-india.com/assets/images/shopify-development-services-laptop.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <a href="#" className="btn3 btn_gap">
                Request A Code
              </a>
              <a href="#" className="btn1">
                See our work
              </a>
            </div>
          </div>
        </div>
      </section>

      <Slider />

      <section className="section" data-aos="fade-up" data-aos-duration={1500}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div
                className="heading row_gap"
                data-aos="fade-up"
                data-aos-duration={2000}
              >
                <h2>Tools &amp; Technologies </h2>
              </div>
            </div>
          </div>
          <div className="row row-cols-lg-6 g-2 row-cols-md-5 row-cols-sm-4 row-cols-3 justify-content-center align-items-center ">
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-1.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-2.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-3.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-4.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-5.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-6.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-7.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-8.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-9.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-10.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-11.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-12.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="bg-body-tertiary">
          <div className="container">
            <div className="row align-items-center">
              <h2 className="section-title">
                Leading Shopify Website Design Company in India
              </h2>
              <p className="py-3">
               Adret is an ISO 9001:2015 certified company that
                specializes in eCommerce website development. Our team of expert
                Shopify web designers creates dynamic, responsive, and secure
                online stores with stunning UI/UX for an unparalleled shopping
                experience. Our Shopify website design services will increase
                customer engagement, resulting in enhanced conversions, and that
                too at an attractive and competitive prices.
              </p>

              <h4>
                Take a look at our diverse Shopify web development solutions:
              </h4>
              <div className="row ">
                <ul className="col-md-4">
                  <li>
                    <i class="ri-arrow-drop-right-line"></i>Design Unique Store
                    Interface
                  </li>
                  <li>
                    <i class="ri-arrow-drop-right-line"></i>Develop Custom
                    Shopify Theme
                  </li>
                  <li>
                    <i class="ri-arrow-drop-right-line"></i>Custom Visual
                    Elements Setup
                  </li>
                  <li>
                    <i class="ri-arrow-drop-right-line"></i>Store Configuration
                    & Setup
                  </li>
                </ul>
                <ul className="col-md-4">
                  <li>
                    <i class="ri-arrow-drop-right-line"></i>Design Unique Store
                    Interface
                  </li>
                  <li>
                    <i class="ri-arrow-drop-right-line"></i>Develop Custom
                    Shopify Theme
                  </li>
                  <li>
                    <i class="ri-arrow-drop-right-line"></i>Custom Visual
                    Elements Setup
                  </li>
                  <li>
                    <i class="ri-arrow-drop-right-line"></i>Store Configuration
                    & Setup
                  </li>
                </ul>
                <ul className="col-md-4">
                  <li>
                    {" "}
                    <i class="ri-arrow-drop-right-line"></i> Design Unique Store
                    Interface
                  </li>
                  <li>
                    {" "}
                    <i class="ri-arrow-drop-right-line"></i> Develop Custom
                    Shopify Theme
                  </li>
                  <li>
                    {" "}
                    <i class="ri-arrow-drop-right-line"></i> Custom Visual
                    Elements Setup
                  </li>
                  <li>
                    {" "}
                    <i class="ri-arrow-drop-right-line"></i> Store Configuration
                    & Setup
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

     <Faq data={data}/>

      <section
        className="section bg_color_secondary"
        data-aos="fade-up"
        data-aos-duration={1500}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-md-7 blog-left wow fadeInLeft"
              data-wow-duration="0.5s"
              data-wow-delay="0.0s"
            >
              <h2 className="section-title">From Our Blog</h2>
              <div className="blog-inner">
                <h4 className="section-subtitle">
                  Magento 2.4 - Everything You Should Know
                </h4>
                <p>
                  Adobe released Magento 2.4 on 28th July 2020, which came with
                  a long list of new features, security enhancements, and bug
                  fixes. While Magento is a popular eCommerce CMS, thousands of
                  online stores are still on Magento 1. However, with this new
                  update Magento has given store owners every reason to migrate
                  to the newer, better version.
                </p>
                <button className="btn1">Read Blog Post</button>
              </div>
            </div>
            <div
              className="col-md-5 hidden-xs blog-right wow fadeInRight"
              data-wow-duration="0.5s"
              data-wow-delay="0.0s"
            >
              <div className="blog-image-holder">
                <img
                  className="msd-lazyload loaded"
                  src="https://www.webguru-india.com/assets/images/digital-marketing-services-blog.jpg"
                  alt="blog-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ShopifyDev;
